import {
  Component,
  OnInit,
  ViewChild,
  ViewContainerRef,
  ComponentFactoryResolver,
  OnDestroy,
  ViewEncapsulation,
} from '@angular/core';

import { Store } from '@ngrx/store';

import { PageState, PageMenuItem } from 'app/store/models/page.model';
import { setMenuItems } from 'app/store/actions/page.action';

@Component({
  selector: 'app-nonauthenticated',
  templateUrl: './nonauthenticated.component.html',
  styleUrls: ['./nonauthenticated.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class NonauthenticatedComponent implements OnInit, OnDestroy {
  @ViewChild('banner', { read: ViewContainerRef, static: true })
  banner: ViewContainerRef;
  bannerInnerHtml: string = null;
  bannerSubtitle: string;

  menuItems: PageMenuItem[] = [
    {
      label: 'home',
      target: 'home',
    },
    {
      label: 'features',
      target: 'features',
    },
    {
      label: 'pricing',
      target: 'pricing',
    },
    {
      label: 'enterprise',
      target: 'enterprise',
    },
    {
      label: 'partners',
      target: 'partners',
    },
    {
      label: 'contact us',
      target: 'contact_us',
    },
  ];

  constructor(
    private store: Store<{ page: PageState }>,
    private fr: ComponentFactoryResolver
  ) {
    this.store.dispatch(setMenuItems({ items: this.menuItems }));
  }

  ngOnInit() {
    this.store.select('page').subscribe((state: PageState) => {
      if (state.banner_component) {
        if (typeof state.banner_component !== 'string' && this.banner) {
          try {
            this.bannerInnerHtml = null;
            const factory = this.fr.resolveComponentFactory(
              state.banner_component as any
            );
            const ref = this.banner.createComponent(factory);
          } catch (e) {
            console.log(
              'could not create instance component from',
              state.banner_component,
              e
            );
          }
        } else {
          let bannerText = `<h1>${state.banner_component}</h1>`;
          if (state.banner_subtitle) {
            bannerText += `<p class="Page_wrapper_banner_static_small">${state.banner_subtitle}</p>`;
          }
          this.bannerInnerHtml = bannerText;
        }
      }
    });

    // this.store.select(getBannerSubtitle).subscribe((subtitle: string) => this.bannerSubtitle = subtitle);
  }

  ngOnDestroy() {
    this.bannerInnerHtml = null;
  }
}
